/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from "react";
import { useRouter } from "next/router";
import TwitterCard from "./TwitterCard";
import DummyTwitterCard from "./DummyTwitterCard";
import { getFunctions, httpsCallable } from "firebase/functions";
import logEvent from "../helpers/logEvent";
import useFireDocListener from "../hooks/useFireDocListener";
import AccountContext from "../context/AccountContext";
import store from "store";

export default function Poll(props) {
  const { firebaseUser, loadedAuth } = useContext(AccountContext);
  const router = useRouter();
  const { pid, selectedChoice } = router.query;
  const [allowSubmit, setAllowSubmit] = useState(true);

  const [poll] = useFireDocListener(`polls/${pid}`);
  const votePath =
    poll &&
    poll.accountId &&
    pid &&
    firebaseUser &&
    `accounts/${poll.accountId}/polls/${pid}/votes/${firebaseUser.uid}`;
  const [vote] = useFireDocListener(votePath);
  const [showLoader, setShowLoader] = useState(false);

  // @ts-ignore
  const parsedChoice = selectedChoice && parseInt(selectedChoice);
  const selectedChoiceNumber =
    poll && !isNaN(parsedChoice) && parsedChoice <= poll.choices.length && parsedChoice >= 0 && parsedChoice;

  // @ts-ignore
  const submittedVote = store.get(pid);
  const ended = poll && new Date() > poll.endAt.toDate();
  // check if poll has loaded and auth is loaded
  const preAutoSubmitTest = !!(poll && submittedVote == undefined && !ended && selectedChoiceNumber && loadedAuth);
  let autoSubmit = false;

  if (preAutoSubmitTest) {
    if (poll.signed) {
      autoSubmit = !!firebaseUser;
    } else {
      autoSubmit = true;
    }
  }

  const showSignInDialog = preAutoSubmitTest && !autoSubmit;

  const handleSubmit = async idx => {
    setShowLoader(true);
    try {
      if (allowSubmit) {
        await httpsCallable(getFunctions(), "submitVote")({ pid, idx });
        // @ts-ignore
        store.set(pid, idx);
        props.showSnack("Your vote has been registered!");
        logEvent("votedViaLink");
        setAllowSubmit(false);
      }
    } catch (error) {
      props.showSnack(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (autoSubmit && !poll.disableAutoSubmit) {
      handleSubmit(selectedChoiceNumber - 1);
    }
  }, [autoSubmit]);

  return poll ? (
    <TwitterCard
      poll={poll}
      // @ts-ignore
      showResults={submittedVote != undefined || ended || vote}
      submittedVote={submittedVote}
      showLoader={showLoader}
      onSubmit={handleSubmit}
      pid={pid}
      showSignInDialog={showSignInDialog}
      message="This polls needs you to sign in to vote."
    />
  ) : (
    <DummyTwitterCard />
  );
}
